export function openTab(evt, tabName) {
  document.querySelectorAll(".card__content").forEach(node => {
    node.style.display = "none";
  });

  document.querySelectorAll(".tab").forEach(node => {
    node.classList.remove("tab__current");
  });

  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.classList.add("tab__current");
}

$(document).ready(function() {
  document.getElementById("tab-link-0").click();
});
